import React, { useContext } from 'react'
import { ReactComponent as IcoBack } from '../../assets/svg/ico_back_arrow.svg'
import { AppContext } from '../App'

const SearchBar = ({ closeAction }) => {
  const { getTranslatedUiLabel, searchKeyword, setSearchKeyword } = useContext(AppContext)

  return <div className="App-search-container">
    <div className="App-search-bar">
      <IcoBack width="36" height="36" style={{padding: '8px'}} onClick={() => closeAction()} />
      <input
        className="App-search-bar-input"
        onChange={(e) => setSearchKeyword(e.target.value)}
        type="text"
        value={searchKeyword}
        placeholder={getTranslatedUiLabel(17)}
        autoFocus
      />
    </div>
  </div>
}

export default SearchBar